module.exports = __webpack_public_path__ + "static/media/08C.508077dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/08C.png
// module id = 283
// module chunks = 0